import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid';
import { useEspecialidades } from '../../data/hooks/useEspecialidades.hook';
import { Especialidad, especialidadesConstants } from '../../data/types/especialidades.types';
import { Spinner } from '../../components/spinner/Spinner.component';
 
interface Entity extends Especialidad {}
const entityConstants = especialidadesConstants
 
export const EspecialidadesBrowse = () => {
	const { data, isPending, isError, error } = useEspecialidades();
	const navigate = useNavigate()
	const queryClient = useQueryClient();
 
	const columns: ColumnConfig[] = [
	  {
		key: 'nombre',
		header: 'Nombre',
		dataType: 'text',
		filterable: true,
		sortable: true,
		horizontalAlign: 'left',
		width: 30
	  },
	  {
		key: 'activo',
		header: 'Activo',
		dataType: 'boolean',
		filterable: true,
		filterBy: 'FORMATTED',
		horizontalAlign: 'left',
		width: 10,
		formatter: (value: boolean) => {
			return Boolean(value) ? 'Activo' : 'No'
		}
	  }
	];
 
	const rowActions = [
	  {
		label: '',
		action: (selected: Entity[]) => navigate(`${entityConstants.navigateToParent}/${selected[0].id}`),
		icon: '✏️'
	  },
	  {
		label: '',
		preset: 'delete',
		config: {
		  apiEndpoint: entityConstants.apiEndpoint,
		  entityName: entityConstants.entityLabel,
		},
		action: (selected: any) => {
		  // queryClient.invalidateQueries({queryKey: ['products']});
		  navigate(entityConstants.apiEndpoint);
		},
		icon: '🗑️'
	  }
  ];

  if (isPending) return <Spinner />

  return (
		<div style={{ margin: '0 150px' }}>
			{isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>}
			{(!isPending && !isError) && <SmartGrid
				data={data || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'nombre', direction: 'desc' }}
				toolbarComponents={[
				  {
					type: 'title',
					title: entityConstants.entityLabel
				  },
				  {
					type: 'command',
					label: `${entityConstants.entityLabelGender === 'F' ? 'Nueva' : 'Nuevo'} ${entityConstants.entityLabel}`,
					onClick: () => navigate(`${entityConstants.navigateToParent}/new`),
				  }
				]}
			/>}
		</div>
	);
 
}
